import { 
  collection, 
  addDoc, 
  query, 
  where, 
  getDocs, 
  serverTimestamp
} from 'firebase/firestore';
import { db } from '../firebase';

const connectionsRef = collection(db, 'connections');

export const createConnection = async (user1Id, user2Id) => {
  try {
    if (!user1Id || !user2Id) {
      throw new Error('Both user IDs are required to create a connection');
    }

    // Sort user IDs to ensure consistent storage
    const users = [user1Id, user2Id].sort();

    // Check if connection already exists
    const existingQuery = query(
      connectionsRef,
      where('users', '==', users)
    );

    const existingDocs = await getDocs(existingQuery);
    if (!existingDocs.empty) {
      return existingDocs.docs[0].id;
    }

    // Create new connection
    const connection = {
      users,
      createdAt: new Date().toISOString(),
      status: 'active'
    };

    const docRef = await addDoc(connectionsRef, connection);
    return docRef.id;
  } catch (error) {
    console.error('Error creating connection:', error);
    throw error;
  }
};

export const checkExistingConnection = async (user1Id, user2Id) => {
  const q1 = query(connectionsRef, 
    where('users', 'array-contains', user1Id)
  );
  
  const snapshot = await getDocs(q1);
  const connection = snapshot.docs.find(doc => 
    doc.data().users.includes(user2Id)
  );

  return connection ? { id: connection.id, ...connection.data() } : null;
};

export const getConnections = async (userId) => {
  try {
    const connectionsQuery = query(
      connectionsRef,
      where('users', 'array-contains', userId),
      where('status', '==', 'active')
    );

    const snapshot = await getDocs(connectionsQuery);
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error('Error getting connections:', error);
    throw error;
  }
}; 